module.exports = __webpack_public_path__ + "img/8ee13f9.png";